import React from 'react';

export const EmailInputIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="19"
    height="18"
    viewBox="0 0 19 18"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.06797 3.75C2.65375 3.75 2.31797 4.08579 2.31797 4.5V13.5C2.31797 13.9142 2.65375 14.25 3.06797 14.25H15.068C15.4822 14.25 15.818 13.9142 15.818 13.5V4.5C15.818 4.08579 15.4822 3.75 15.068 3.75H3.06797ZM0.817966 4.5C0.817966 3.25736 1.82533 2.25 3.06797 2.25H15.068C16.3106 2.25 17.318 3.25736 17.318 4.5V13.5C17.318 14.7426 16.3106 15.75 15.068 15.75H3.06797C1.82533 15.75 0.817966 14.7426 0.817966 13.5V4.5Z"
      fill="var(--color-text-muted)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.934959 4.84775C1.15711 4.49815 1.62061 4.39484 1.97021 4.61699L8.69533 8.89048C8.80714 8.9601 8.93623 8.99701 9.06797 8.99701C9.1997 8.99701 9.32879 8.9601 9.4406 8.89048L9.44227 8.88944L16.1657 4.61699C16.5153 4.39484 16.9788 4.49815 17.201 4.84775C17.4231 5.19735 17.3198 5.66085 16.9702 5.88301L10.2387 10.1606C9.88777 10.3804 9.48205 10.497 9.06797 10.497C8.65388 10.497 8.24817 10.3804 7.89727 10.1606L7.89321 10.158L1.16572 5.88301C0.81612 5.66085 0.712805 5.19735 0.934959 4.84775Z"
      fill="var(--color-text-muted)"
    />
  </svg>
);
